import routes from 'js/core_pre_webpack/routes';
import { analyticsSourcePage } from 'js/analytics_v2/tabs';
import {
  AnalyticsAccessContext,
  withAnalyticsLandingContext,
} from 'js/analytics_v2/options';

export const analyticsUpgradeUrl = (
  parameters: Parameters<typeof routes.upgrade_url>[0],
): string => {
  const mount =
    typeof document === 'undefined'
      ? null
      : document.querySelector('script[data-component-name="Analytics"]');
  const props: {
    newAnalytics?: boolean;
    analyticsContext?: AnalyticsAccessContext;
  } = mount ? JSON.parse(mount.textContent || '{}') : {};
  return withAnalyticsLandingContext(
    routes.upgrade_url(
      props.newAnalytics
        ? {
            ...parameters,
            feature: 'analytics_dashboard',
            analytics_page: analyticsSourcePage(window.location.pathname),
          }
        : parameters,
    ),
    props.newAnalytics ? props.analyticsContext : undefined,
  );
};
